// Vision Live Conversation feature flag (frontend).
//
// Small, single-purpose flag reader for the C1 shared-MediaStream
// Voice-during-Vision behavior and the C2 current-frame visual
// grounding adapter. Off by default: when disabled, the existing
// record-and-summarize Vision behavior is preserved unchanged.
//
// Sources (first non-empty wins):
//   1. window.__leviVisionLiveOverride  (QA toggle without rebuild)
//   2. process.env.REACT_APP_LEVI_VISION_LIVE_CONVERSATION
//   3. default: false
//
// "1", "true", "on", "yes" (case-insensitive) → true; else false.

const _truthy = (v) => {
  if (v === true) return true;
  if (v == null) return false;
  const s = String(v).trim().toLowerCase();
  return s === "1" || s === "true" || s === "on" || s === "yes";
};

export function isVisionLiveConversationEnabled() {
  try {
    if (typeof window !== "undefined"
        && window.__leviVisionLiveOverride != null) {
      return _truthy(window.__leviVisionLiveOverride);
    }
  } catch { /* noop */ }
  try {
    return _truthy(process.env.REACT_APP_LEVI_VISION_LIVE_CONVERSATION);
  } catch { /* noop */ }
  return false;
}
